// extracted by mini-css-extract-plugin
export var primitiveLabel = "_uc-0";